import { typesenseClient } from '../typesense';
import { CardRuleSets } from '../models/CardRuleEngine';

export async function getCardEngineRules(props: { serial: string }): Promise<CardRuleSets> {
    const collection = "card-engine-rules";

    const results = await typesenseClient
        .collections<CardRuleSets>(collection)
        .documents(props.serial)
        .retrieve();

    return results;
}